import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@sprint-backoffice/app/app.component';
import { appConfig } from '@sprint-backoffice/app/app.config';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
